<template>
  <div class="third-router-container">
    <img v-if="image" :src="image" class="eventImg">
    <div class="event-sep">
      <el-breadcrumb separator="/" class="event-sep-mbx">
        <el-breadcrumb-item v-for="(item, index) in routerList" :key="index">
          <span :class="index !== 0 ? 'event-sep-txt2' : 'event-sep-txt'" @click="jumpPath(item.path, index)">{{ item.name }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="routh-title">
        {{ selVal }}
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'

export default {
  props: {
    image: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      routerList: [],
      selVal: ''
    }
  },
  mounted() {
    this.getMenu()
  },
  methods: {
    getMenu() {
      this.menus = router.options.routes.filter(item => {
        if (item.children) {
          return item.children
        }
      })[0].children
      const allRouth = []
      this.menus.forEach(item => {
        if (item.children) {
          item.children.forEach(cItem => {
            allRouth.push(cItem)
          })
        } else {
          allRouth.push(item)
        }
      })
      this.routerList = []
      this.thirdItem = ''
      // const url = (this.$store.state.PATH.indexOf('?') !== -1) ? this.$store.state.PATH.substring(0, this.$store.state.PATH.indexOf('?')) : this.$store.state.PATH
      allRouth.forEach(item => {
        if (item.path === this.$route.path) {
          this.thirdItem = item
          this.routerList.push({ name: item.label, path: item.path })
        }
      })
      allRouth.forEach(item => {
        if (this.thirdItem.meta && (item.path === this.thirdItem.meta.jumpPath)) {
          const eItem = { name: item.label, path: item.path }
          if (this.routerList.indexOf(eItem) === -1) {
            this.routerList.unshift({ name: item.label, path: item.path })
          }
        }
      })
      const thirdRouter = this.menus.map(cItem => {
        const tItem = cItem.children ? (cItem.children.indexOf(this.thirdItem) !== -1) ? cItem : '' : ''
        return tItem
      })
      thirdRouter.forEach(item => {
        if (item.children) {
          this.routerList.unshift({ name: item.label, path: item.path })
        }
      })
      this.selVal = this.routerList[this.routerList.length - 1].name
    },
    jumpPath(path, index) {
      if (index !== 0) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.third-router-container {
  display: flex;
  justify-content: flex-start;

  .eventImg {
    width: 70px;
    height: 70px;
    margin-right: 32px;
  }

  .routh-title {
    font-size: 18px;
    font-weight: 600;
    color: #212121;
    line-height: 25px;
  }
  .event-sep {
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    /deep/ .el-input__inner{
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #051C46;
      line-height: 40px;
      border: none;
      background-color: transparent;
      padding: 0;
    }

    /deep/ .el-select .el-input .el-select__caret{
      color: transparent;
    }

    .event-sep-mbx {
      height: 22px;
      width: 100%;

      .event-sep-txt {
        height: 22px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(26, 55, 107, 0.6);
        line-height: 22px;
      }

      .event-sep-txt2 {
        height: 22px;
        font-size: 14px;
        font-weight: 400;
        color: #1A376B;
        line-height: 22px;
        cursor:pointer
      }
    }

    .event-sep-til {
      margin-top: 12px;
      height: 40px;
      font-size: 28px;
      font-weight: 600;
      color: #051C46;
      line-height: 40px;
      text-align: left;
      border: none;
    }
  }
}
</style>
